import axiosInstance from "../axios";

const courseStatus = {
  drafts: 1,
  isReview: 2,
  published: 3,
  archived: 4,
};

const fetchCourses = async (page, category, level, subCategory) => {
  return axiosInstance
    .get(
      category === null && level === null
        ? subCategory !== null
          ? `course?subCategory=${encodeURIComponent(
              subCategory.toLowerCase()
            )}&page=${page}`
          : `course?page=${page}`
        : level === null
        ? `course?category=${encodeURIComponent(
            category.toLowerCase()
          )}&page=${page}`
        : category === null
        ? `course?level=${level}&page=${page}`
        : `course?category=${encodeURIComponent(
            category.toLowerCase()
          )}&level=${level}&page=${page}`
    )
    .then(({ data }) => data.data);
};

const myCourses = async (key, url, page) => {
  return axiosInstance
    .get(
      `${url}?page=${page}${
        courseStatus[key] ? `&status=${courseStatus[key]}` : ""
      }`
    )
    .then(({ data }) => {
      return data.data;
    });
};

const purchasedCourses = async (page) => {
  return axiosInstance
    .get(`course/purchased?page=${page}`)
    .then(({ data }) => data.data)
    .catch((res) => {
      console.log(res);
    });
};

const profileResetPassword = async (data) => {
  return axiosInstance.post(`/reset`, data);
};

const profileForgetPassword = async (data) => {
  return axiosInstance.post(`/forgot-password`, data);
};

const updateProfile = async (profileData) => {
  return axiosInstance.put(`user/profile`, profileData);
};

const viewAwardCourse = async (page) => {
  return axiosInstance
    .get(`course/all/certificates?page=${page}`)
    .then(({ data }) => data.data)
    .catch((res) => {
      console.log(res);
    });
};

const postContactDetail = async (data) => {
  return axiosInstance.post(`/contact/demo-request`, data);
};

const userSignup = async (data) => {
  return axiosInstance.post(`/sign-up`, data);
};

const userStatics = async () => {
  return axiosInstance.get(`admin/statistics`);
};

export const courseService = {
  myCourses,
  fetchCourses,
  purchasedCourses,
  updateProfile,
  profileForgetPassword,
  profileResetPassword,
  viewAwardCourse,
  postContactDetail,
  userSignup,
  userStatics,
};
